import * as React from "react";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { ReactComponent as CalendarIcon } from "../assets/images/calender-icon.svg";

const CDatePicker = ({
  label,
  value,
  onChange,
  error,
  helperText,
  disabled,
  className,
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          onChange?.(newValue ? newValue.toDate() : null);
        }}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            error={!!error}
            inputProps={{
              ...params.inputProps,
              readOnly: true, 
            }}
            helperText={error ? error : helperText}
          />
        )}
        components={{ OpenPickerIcon: CalendarIcon }}
        className={`CDatpicker ${className}`}
        {...props}
      />
    </LocalizationProvider>
  );
};

CDatePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CDatePicker;
